import { gsap } from 'gsap'
// import { Draggable } from 'gsap/Draggable'
import { InertiaPlugin } from 'gsap/InertiaPlugin'
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

gsap.registerPlugin(InertiaPlugin)

export default class HorizontalLoop {
  constructor(container, config) {
    // ------------------------------------------------------------
    // 変数宣言
    // ------------------------------------------------------------
    const _this = this
    this.config = config || {}
    this.container = container
    this.onChange = this.config.onChange
    this.snap = this.config.snap

    this.loopedSlides = gsap.utils.toArray(
      '.swiper-slide',
      document.querySelector(this.container)
    )
    this.slideLength = this.loopedSlides.length
    this.speed = 1000

    // swiper 設定
    this.option = {
      spaceBetween: 0,
      initialSlide: 0,
      speed: this.speed,
      longSwipesRatio: 0.15,
      grabCursor: true,
      longSwipes: true,
      longSwipesRatio: 0.75,
      centeredSlides: true,
      slidesPerView: 'auto',
      loop: true,
      loopedSlides: this.slideLength,
      mousewheel: {
        invert: false,
        thresholdDelta: 2.0
      }
    }

    this.swiper = new Swiper(this.container, this.option)
    this.swiper.on('slideChange', () => this.slideChange())

    this.loopedSlides = gsap.utils.toArray(
      '.swiper-slide',
      document.querySelector(this.container)
    )
  }

  slideChange() {
    const elm = this.loopedSlides[this.swiper.activeIndex]
    const index = gsap.utils.wrap(0, this.slideLength, this.swiper.activeIndex)

    this.onChange && this.onChange(elm, index)
  }

  changeIndex(index, speed = this.speed) {
    this.swiper.slideToLoop(index, speed)
  }

  next() {
    this.swiper.slideNext(this.speed)
  }
  previous() {
    this.swiper.slidePrev(this.speed)
  }
}

// export default class HorizontalLoop {
//   constructor(items, config) {
//     // ------------------------------------------------------------
//     // 変数宣言
//     // ------------------------------------------------------------
//     const _this = this // スコープの違いがある際に使用する
//     this.items = gsap.utils.toArray(items) // スライダー対象要素の配列
//     this.config = config || {} // オプション設定用のオブジェクト
//     this.onChange = this.config.onChange // タイムラインの更新中に発火するイベント
//     this.lastIndex = 0 // ??

//     // タイムラインの作成
//     this.tl = gsap.timeline({
//       repeat: this.config.repeat,
//       onUpdate:
//         this.onChange &&
//         function () {
//           let i = _this.closestIndex()
//           if (_this.lastIndex !== i) {
//             _this.lastIndex = i
//             _this.onChange(_this.items[i], i)
//           }
//           // console.log('onchange', _this.items[i], _this.lastIndex)
//         },
//       paused: this.config.paused,
//       defaults: { ease: 'none' },
//       onReverseComplete: function () {
//         _this.tl.totalTime(_this.tl.rawTime() + _this.tl.duration() * 100)
//       }
//     })

//     this.length = this.items.length // itemsの要素の数
//     this.startX = this.items[0].offsetLeft // 最初の要素の位置(x)

//     // スライダー対象要素の関係配列
//     this.times = [] // 要素の位置指定用
//     this.widths = [] // 要素の横幅
//     this.spaceBefore = [] // 要素の左側のスペース
//     this.xPercents = [0] // 要素のtransform.translateXの％値

//     this.curIndex = 0 // アクティブな要素のインデックス
//     this.indexIsDirty = false // 要素が移動中か判定(ドラッグの時だけたぶん)
//     this.center = this.config.center // アクティブな要素をセンターに配置するのか
//     this.pixelsPerSecond = (this.config.speed || 1) * 100 // ??
//     this.timeOffset = 0 // アクティブな要素を中央に配置するための値をdurationの値に変換したもの
//     this.container =
//       this.center === true
//         ? this.items[0].parentNode
//         : gsap.utils.toArray(this.center)[0] || this.items[0].parentNode // 親要素(wrapper)
//     this.totalWidth // スライダー対象の要素全体の幅
//     this.timeWrap // 引数の値を０〜totalDurationの間の値で返す(gsap.utils.wrap)
//     this.proxy // (ドラッグの時に使用)
//     this.draggable // draggableオブジェクト
//     this.controller = new AbortController()

//     // ------------------------------------------------------------
//     // 初期の処理
//     // ------------------------------------------------------------
//     gsap.set(this.items, { x: 0 })
//     this.populateWidths()
//     this.populateTimeline()
//     this.populateOffsets()
//     window.addEventListener('resize', () => this.refresh(true))
//     this.tl.progress(1, true).progress(0, true) // pre-render for performance
//     if (this.config.reversed) {
//       this.tl.vars.onReverseComplete()
//       this.tl.reverse()
//     }

//     // ここにドラッグなどのアクション記載
//     if (this.config.draggable) {
//       this.isDraggable()
//     }

//     // wheelアニメーション
//     if (this.config.wheel) {
//       this.isWheel()
//     }

//     this.closestIndex(true)
//     this.lastIndex = this.curIndex
//     this.onChange && this.onChange(items[this.curIndex], this.curIndex)

//     // console.log('this.length', this.length)
//     // console.log('this.startX', this.startX)
//     // console.log('this.times', this.times)
//     // console.log('this.widths', this.widths)
//     // console.log('this.spaceBefore', this.spaceBefore)
//     // console.log('this.xPercents', this.xPercents)
//     // console.log('this.curIndex', this.curIndex)
//     // console.log('this.indexIsDirty', this.indexIsDirty)
//     // console.log('this.center', this.center)
//     // console.log('this.pixelsPerSecond', this.pixelsPerSecond)
//     // console.log('this.timeOffset', this.timeOffset)
//     // console.log('this.container', this.container)
//     // console.log('this.totalWidth', this.totalWidth)
//     // console.log('this.timeWrap', this.timeWrap)
//     // console.log('this.proxy', this.proxy)
//   }

//   // ----------------------------------------------------------------------------------
//   // その他関数
//   // ----------------------------------------------------------------------------------
//   snap(v) {
//     const snapConfig =
//       this.config.snap === false
//         ? (v) => v
//         : gsap.utils.snap(this.config.snap || 1)
//     return snapConfig(v)
//   }
//   getTotalWidth() {
//     const lastItemOffsetLeft = this.items[this.length - 1].offsetLeft
//     const lastItemTransformX =
//       (this.xPercents[this.length - 1] / 100) * this.widths[this.length - 1]
//     const startX = this.startX
//     const spaceBefore = this.spaceBefore[0]
//     const lastItemWidth =
//       this.items[this.length - 1].offsetWidth *
//       gsap.getProperty(this.items[this.length - 1], 'scaleX')
//     const paddingRight = parseFloat(this.config.paddingRight) || 0
//     // console.log(lastItemOffsetLeft, lastItemTransformX, startX, spaceBefore, lastItemWidth, paddingRight)

//     return (
//       lastItemOffsetLeft +
//       lastItemTransformX -
//       startX +
//       spaceBefore +
//       lastItemWidth +
//       paddingRight
//     )
//   }

//   populateWidths() {
//     let b1 = this.container.getBoundingClientRect()
//     let b2

//     this.items.forEach((el, i) => {
//       this.widths[i] = parseFloat(gsap.getProperty(el, 'width', 'px'))
//       this.xPercents[i] = this.snap(
//         (parseFloat(gsap.getProperty(el, 'x', 'px')) / this.widths[i]) * 100 +
//           gsap.getProperty(el, 'xPercent')
//       )
//       b2 = el.getBoundingClientRect()
//       this.spaceBefore[i] = b2.left - (i ? b1.right : b1.left)
//       b1 = b2
//     })
//     gsap.set(this.items, {
//       xPercent: (i) => this.xPercents[i]
//     })
//     this.totalWidth = this.getTotalWidth()

//     // console.log('widths', this.widths)
//     // console.log('xPercents', this.xPercents)
//     // console.log('spaceBefore', this.spaceBefore)getClosest
//     // console.log('totalWidth', this.totalWidth)
//   }

//   populateOffsets() {
//     this.timeOffset = this.center
//       ? (this.tl.duration() * (this.container.offsetWidth / 2)) /
//         this.totalWidth
//       : 0
//     this.center &&
//       this.times.forEach((t, i) => {
//         this.times[i] = this.timeWrap(
//           this.tl.labels[`label${i}`] +
//             (this.tl.duration() * this.widths[i]) / 2 / this.totalWidth -
//             this.timeOffset
//         )
//       })
//     // console.log('populateOffsets', this.timeOffset, this.times)
//   }

//   getClosest(values, value, wrap) {
//     //
//     let i = values.length, // this.times[]
//       closest = 1e10, // 10000000000
//       index = 0,
//       d

//     while (i--) {
//       d = Math.abs(values[i] - value)
//       if (d > wrap / 2) {
//         d = wrap - d
//       }
//       if (d < closest) {
//         closest = d
//         index = i
//       }
//     }
//     // console.log('getClosest', index)
//     return index
//   }

//   populateTimeline() {
//     let i, item, curX, distanceToStart, distanceToLoop
//     this.tl.clear()
//     for (i = 0; i < this.length; i++) {
//       item = this.items[i]
//       curX = (this.xPercents[i] / 100) * this.widths[i]
//       distanceToStart =
//         item.offsetLeft + curX - this.startX + this.spaceBefore[0]
//       distanceToLoop =
//         distanceToStart + this.widths[i] * gsap.getProperty(item, 'scaleX')
//       this.tl
//         .to(
//           item,
//           {
//             xPercent: this.snap(
//               ((curX - distanceToLoop) / this.widths[i]) * 100
//             ),
//             duration: distanceToLoop / this.pixelsPerSecond
//           },
//           0
//         )
//         .fromTo(
//           item,
//           {
//             xPercent: this.snap(
//               ((curX - distanceToLoop + this.totalWidth) / this.widths[i]) * 100
//             )
//           },
//           {
//             xPercent: this.xPercents[i],
//             duration:
//               (curX - distanceToLoop + this.totalWidth - curX) /
//               this.pixelsPerSecond,
//             immediateRender: false
//           },
//           distanceToLoop / this.pixelsPerSecond
//         )
//         .add(`label${i}`, distanceToStart / this.pixelsPerSecond)

//       // console.log(`${i+1} to(%)`, this.snap((curX - distanceToLoop) / this.widths[i] * 100))
//       // console.log(`${i+1} to(%)[duration]`, distanceToLoop / this.pixelsPerSecond)
//       // console.log(`${i+1} fromTo(%)`, this.snap((curX - distanceToLoop + this.totalWidth) / this.widths[i] * 100), this.xPercents[i])
//       // console.log(`${i+1} fromTo(%)[duration]`, (curX - distanceToLoop + this.totalWidth - curX) / this.pixelsPerSecond,)
//       // console.log(`${i+1} add label`, distanceToStart / this.pixelsPerSecond)

//       this.times[i] = distanceToStart / this.pixelsPerSecond
//     }
//     // console.log('populateIimeline', this.times, this.tl.duration())
//     this.timeWrap = gsap.utils.wrap(0, this.tl.duration())
//   }

//   refresh(deep) {
//     this.controller.abort()
//     this.controller = new AbortController()

//     let progress = this.tl.progress()
//     this.tl.progress(0, true)
//     this.populateWidths()
//     deep && this.populateTimeline()
//     this.populateOffsets()
//     this.isDraggable()
//     this.isWheel()
//     deep && this.tl.draggable
//       ? this.tl.time(times[this.curIndex], true)
//       : this.tl.progress(progress, true)
//   }

//   // ----------------------------------------------------------------------------------
//   // time line function
//   // ----------------------------------------------------------------------------------
//   toIndex(index, vars) {
//     vars =
//       vars ||
//       ({}(Math.abs(index - this.curIndex) > this.length / 2) &&
//         (index += index > this.curIndex ? -this.length : this.length))
//     let newIndex = gsap.utils.wrap(0, this.length, index)
//     let time = this.times[newIndex]
//     if (
//       time > this.tl.time() !== index > this.curIndex &&
//       index !== this.curIndex
//     ) {
//       time += this.tl.duration() * (index > this.curIndex ? 1 : -1)
//     }
//     if (time < 0 || time > this.tl.duration()) {
//       vars.modifiers = { time: this.timeWrap }
//     }
//     this.curIndex = newIndex
//     vars.overwrite = true
//     gsap.killTweensOf(this.proxy)

//     // console.log('[toIndex]', ` time: ${time}`, ` timeWrap(time): ${this.timeWrap(time)}`)
//     return vars.duration === 0
//       ? this.tl.time(this.timeWrap(time))
//       : this.tl.tweenTo(time, vars)
//   }
//   closestIndex(setCurrent) {
//     // console.log('tl.time()', this.tl.time())
//     let index = this.getClosest(this.times, this.tl.time(), this.tl.duration())
//     // console.log('closestIndex', index)
//     if (setCurrent) {
//       this.curIndex = index
//       this.indexIsDirty = false
//     }
//     return index
//   }
//   current() {
//     return this.indexIsDirty ? this.closestIndex(true) : this.curIndex
//   }
//   next(vars) {
//     // console.log('next', this.current(), vars)
//     return this.toIndex(this.current() + 1, vars)
//   }
//   previous(vars) {
//     // console.log('previous', this.current(), vars)
//     return this.toIndex(this.current() - 1, vars)
//   }
//   changeIndex(i, vars) {
//     // console.log('changeIndex', this.current(), vars)
//     let index = 0,
//       value
//     while (index <= this.times.length) {
//       if (gsap.utils.wrap(0, this.times.length, this.current() + index) === i) {
//         value = index
//         break
//       }
//       if (gsap.utils.wrap(0, this.times.length, this.current() - index) === i) {
//         value = -index
//         break
//       }
//       index++
//     }
//     return this.toIndex(this.current() + value, vars)
//   }

//   // ----------------------------------------------------------------------------------
//   // ドラッグ関係のアニメーション
//   // ----------------------------------------------------------------------------------
//   isDraggable() {
//     // ドラッグ用の変数宣言
//     // -------------------------------
//     const container = this.container
//     this.snapBorder = []
//     this.dragActive = false
//     this.dragStartX = 0
//     this.dragMove = [0]
//     this.containerWidth = parseFloat(gsap.getProperty(container, 'width', 'px'))
//     this.goalValue = 0
//     // アニメーション関係 関数等々
//     // -------------------------------
//     this.setSnapBorder()
//     // console.log('times', this.times)
//     // console.log('timeOffset', this.timeOffset)
//     // console.log('snapBorder', this.snapBorder, this.tl.duration())
//     // console.log('返り値：', this.snapValue(this.times, 32, this.tl.duration()))

//     if (!this.isTouchDevice()) {
//       container.addEventListener('mousedown', (e) => this.isMouseDown(e), {
//         signal: this.controller.signal
//       })
//       container.addEventListener('mouseup', (e) => this.isMouseUp(e), {
//         signal: this.controller.signal
//       })
//       container.addEventListener('mouseleave', (e) => this.isMouseUp(e), {
//         signal: this.controller.signal
//       })
//       container.addEventListener('mousemove', (e) => this.isMouseMove(e), {
//         signal: this.controller.signal
//       })
//     } else {
//       container.addEventListener('touchstart', (e) => this.isTouchStart(e), {
//         signal: this.controller.signal
//       })
//       container.addEventListener('touchend', (e) => this.isTouchEnd(e), {
//         signal: this.controller.signal
//       })
//       container.addEventListener('touchmove', (e) => this.isTouchMove(e), {
//         signal: this.controller.signal
//       })
//     }
//   }
//   // マウス用 (ドラッグのやつ)
//   // ---------------------------------------------------------------
//   isMouseDown(e) {
//     e.preventDefault()
//     this.dragStartX = e.clientX
//     this.dragActive = true
//     this.dragAnimation()

//     this.wheelActive = false
//   }
//   isMouseUp(e) {
//     if (this.dragActive) {
//       e.preventDefault()
//       this.dragActive = false
//     }
//   }
//   isMouseMove(e) {
//     if (this.dragActive) {
//       e.preventDefault()
//       gsap.killTweensOf(this.tl)

//       const a = this.dragStartX - e.clientX
//       this.dragMove.push(a)
//       if (this.dragMove.length > 15) this.dragMove.shift()

//       this.dragStartX = e.clientX
//     }
//   }

//   // タッチデバイス用 (ドラッグのやつ)
//   // ---------------------------------------------------------------
//   isTouchStart(e) {
//     e.preventDefault()
//     this.dragStartX = e.changedTouches[0].clientX
//     this.dragActive = true
//     this.dragAnimation()

//     this.wheelActive = false
//   }
//   isTouchEnd(e) {
//     if (this.dragActive) {
//       e.preventDefault()
//       this.dragActive = false
//     }
//   }
//   isTouchMove(e) {
//     if (this.dragActive) {
//       e.preventDefault()
//       gsap.killTweensOf(this.tl)

//       const a = this.dragStartX - e.changedTouches[0].clientX
//       this.dragMove.push(a)
//       if (this.dragMove.length > 15) this.dragMove.shift()

//       this.dragStartX = e.changedTouches[0].clientX
//     }
//   }

//   dragAnimation = () => {
//     this.indexIsDirty = true
//     const curTime = this.tl.time()
//     if (this.dragMove.length) this.goalValue += this.dragMove.shift()

//     // console.log(this.dragActive)

//     // 目標値の設定

//     if (Math.abs(this.goalValue) > 0.5) {
//       // 通常処理
//       this.curValue = this.goalValue * 0.05
//       this.tl.time(
//         gsap.utils.wrap(0, this.tl.duration(), this.curValue * 0.025 + curTime)
//       )
//       this.goalValue =
//         Math.abs(this.goalValue - this.curValue) > 1.0
//           ? this.goalValue - this.curValue
//           : 0
//     } else {
//       // 目標値設定
//       const v = this.snapValue(this.times, curTime, this.tl.duration())
//       // console.log(v, curTime, this.tl.duration())
//       this.tl.time(gsap.utils.wrap(0, this.tl.duration(), curTime + v * 0.05))
//     }

//     if (Math.abs(this.goalValue) > 0 || this.dragActive) {
//       requestAnimationFrame(this.dragAnimation)
//     } else if (!this.wheelActive) {
//       const curTime = this.tl.time()
//       const val = gsap.utils.snap(this.times, curTime)
//       const dur = Math.abs(val - curTime) * 0.45
//       this.current()
//       this.tl
//         .tweenTo(val, {
//           duration: dur > 1.4 ? dur : 1.4,
//           ease: 'Power2.easeInOut'
//         })
//         .then(() => {
//           this.indexIsDirty = false
//         })
//     }
//   }

//   setSnapBorder() {
//     const d = this.tl.duration()
//     // const offset = (d % this.timeOffset > 0)? (d % this.timeOffset) / 2 : 0
//     const ts = this.times
//     ts.forEach((data, i) => {
//       this.snapBorder[i] = {}
//     })
//     ts.forEach((data, index) => {
//       let offset, after, cur, next
//       next = ts[gsap.utils.wrap(0, ts.length, index + 1)]
//       cur = data > next ? data - d : data
//       after = gsap.utils.wrap(0, d, (next - cur) / 2 + cur)

//       this.snapBorder[index].after = after
//       this.snapBorder[gsap.utils.wrap(0, ts.length, index + 1)].before = after
//     })
//   }

//   snapValue(list, time, duration) {
//     let value = 0
//     const t = time >= duration ? 0 : gsap.utils.wrap(0, duration, time)
//     list.forEach((data, i) => {
//       const sb = this.snapBorder[i]
//       const after = sb.after
//       const before = sb.before
//       if (before > after) {
//         const afterOver = after + duration
//         const beforeUnder = before - duration
//         let dataAnother = (data - duration) % duration
//         if (dataAnother === 0) dataAnother = duration
//         if (beforeUnder < t && after >= t && t !== 0) {
//           value =
//             Math.abs(data - time) < Math.abs(dataAnother - time)
//               ? data - time
//               : dataAnother - time
//           return
//         } else if (before < t && afterOver >= t && t !== 0) {
//           // value =  data - time
//           value =
//             Math.abs(data - time) < Math.abs(dataAnother - time)
//               ? data - time
//               : dataAnother - time
//           return
//         }
//       } else if (before < t && after >= t && t !== 0) {
//         value = data - time
//         return
//       }
//     })
//     // console.log('value', value)
//     return value
//   }

//   // ----------------------------------------------------------------------------------
//   // Wheel function
//   // ----------------------------------------------------------------------------------
//   isWheel() {
//     // マウsウィール用の変数宣言
//     // -------------------------------
//     const container = this.container
//     this.snapBorder = []
//     this.wheelActive = false
//     this.wheelMove = [0]
//     this.containerWidth = parseFloat(gsap.getProperty(container, 'width', 'px'))
//     this.wheelGoalValue = 0
//     // アニメーション関係 関数等々
//     // -------------------------------
//     this.setSnapBorder()

//     container.addEventListener('wheel', (e) => this.isWheelAction(e), {
//       signal: this.controller.signal
//     })
//   }

//   isWheelAction(e) {
//     e.preventDefault()
//     gsap.killTweensOf(this.tl)
//     if (!this.wheelActive) {
//       this.wheelActive = true
//       this.dragActive = false
//     }

//     // const a = e.wheelDelta
//     const a = -e.wheelDelta
//     this.wheelMove.push(a)
//     if (this.wheelMove.length > 15) this.wheelMove.shift()
//     // console.log('wheelMove', this.wheelMove)

//     if (this.wheelActive) this.wheelAnimation()
//   }

//   wheelAnimation = () => {
//     this.indexIsDirty = true
//     const curTime = this.tl.time()
//     if (this.wheelMove.length) this.wheelGoalValue += this.wheelMove.shift()

//     // if (Math.abs(this.wheelGoalValue) <= 100) {
//     //   // console.log('wheelGoalValue', this.wheelGoalValue)
//     //   const a = this.tl.time()
//     //   const b = this.wheelGoalValue * 0.01
//     //   const c = gsap.utils.wrap(0, this.tl.duration(), a + b)
//     //   const d = gsap.utils.snap(this.times, a + b)
//     //   const v = this.snapValue(this.times, curTime, c)
//     //   console.log('止まる場所', d, c, v)
//     //   this.wheelGoalValue = v * 100 * 0.2
//     // }

//     // 通常処理
//     if (this.wheelGoalValue > window.innerWidth)
//       this.wheelGoalValue = window.innerWidth
//     this.curValue = this.wheelGoalValue * 0.005
//     // console.log(this.wheelGoalValue, this.curValue)
//     this.tl.time(
//       gsap.utils.wrap(0, this.tl.duration(), this.curValue * 0.01 + curTime)
//     )
//     this.wheelGoalValue =
//       Math.abs(this.wheelGoalValue - this.curValue) > 10.0
//         ? this.wheelGoalValue - this.curValue
//         : 0

//     if (Math.abs(this.wheelGoalValue) > 0) {
//       requestAnimationFrame(this.wheelAnimation)
//     } else if (this.wheelActive) {
//       const curTime = this.tl.time()
//       const val = gsap.utils.snap(this.times, curTime)
//       const dur = Math.abs(val - curTime) * 0.45
//       this.current()
//       this.tl
//         .tweenTo(val, {
//           duration: dur > 1.4 ? dur : 1.4,
//           ease: 'Power2.easeInOut'
//         })
//         .then(() => {
//           this.indexIsDirty = false
//           this.wheelActive = false
//         })
//     }
//   }

//   // common function
//   // ----------------------------------------------------------------
//   isTouchDevice() {
//     if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)) {
//       return true
//     } else {
//       return false
//     }
//   }
// }
